import * as actionTypes from './actionTypes'

export const handleSelectedEvent = val => {
  return {
    type: actionTypes.HANDLE_SELECTED_EVENT,
    value: val
  }
}
